import { render } from "./GuestProfile.vue?vue&type=template&id=62e20d98&scoped=true&ts=true"
import script from "./GuestProfile.vue?vue&type=script&lang=ts"
export * from "./GuestProfile.vue?vue&type=script&lang=ts"

import "./GuestProfile.vue?vue&type=style&index=0&id=62e20d98&lang=scss&scoped=true"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e20d98"]])

export default __exports__